<template>
	<page>
		<module :title="verify ? '发放任务审核' : '发放任务详情'">
			<div v-if="taskInfo">
				<c-detail title="基础信息">
					<c-detail-item label="任务类型">
                        <span v-if="taskInfo.task_type == 0" style="color:darkcyan">自动发放</span>
                        <span v-if="taskInfo.task_type == 1" style="color:darkgoldenrod">自行领券</span>
                    </c-detail-item>
					<c-detail-item label="任务名称">{{taskInfo.task_name}}</c-detail-item>
					<c-detail-item label="审核状态">
                        <template v-slot="{data}">
                            <span v-if="taskInfo.state == 0" style="color:#999">草稿</span>
                            <span v-if="taskInfo.state == 1" style="color:dodgerblue">待审核</span>
                            <span v-if="taskInfo.state == 2" style="color:green">审核通过</span>
                            <span v-if="taskInfo.state == -1" style="color:red">审核驳回</span>
                        </template>
                    </c-detail-item>
					<c-detail-item label="任务备注">{{taskInfo.remark}}
                        <span v-if="taskInfo.remark">{{taskInfo.remark}}</span>
                        <span v-else>--</span>
                    </c-detail-item>
                    <c-detail-item label="发放状态" v-if="taskInfo.send_state != 0">
                        <!--发放状态：0：待发放，1：已发放，2：终止发放，3：发放异常-->
                        <span v-if="taskInfo.state == 2">
                            <span v-if="taskInfo.task_type == 0 && taskInfo.send_state == 0" style="color:#999">待发放</span>
                            <span v-else-if="taskInfo.task_type == 1 && taskInfo.send_state == 0" style="color:dodgerblue">领取中</span>
                            <span v-else-if="taskInfo.task_type == 0 && taskInfo.send_state == 1" style="color:green">发放成功</span>
                            <span v-else-if="taskInfo.task_type == 0 && taskInfo.send_state == 2" style="color:gray">终止发放</span>
                            <span v-else-if="taskInfo.task_type == 0 && taskInfo.send_state == 3" style="color:red">发放异常</span>
                        </span>
                        <span v-else>--</span>
                    </c-detail-item>
                    <c-detail-item label="发放结果备注" v-if="taskInfo.send_state != 0">
                        <div v-html="taskInfo.error_reason_text"></div>
                    </c-detail-item>
                    <c-detail-item label="目标用户类型">
                        <template v-slot="{data}">
                            <span v-if="taskInfo.task_user_type == 0" style="color:#999">全部用户</span>
                            <span v-if="taskInfo.task_user_type == 1" style="color:dodgerblue">新用户</span>
                            <span v-if="taskInfo.task_user_type == 2" style="color:green">指定用户</span>
                        </template>
                    </c-detail-item>
                    <c-detail-item label="目标用户等级">
                        <template v-slot="{data}">
                            <span v-if="taskInfo.visible_user_level_name && taskInfo.visible_user_level_name == '全部等级'" style="color:blue">全部等级</span>
                            <span v-else v-for="(item, i) in taskInfo.visible_user_level_name.split(',')" :key="i" style="color:darkslategrey;display: block;">{{item}}</span>
                        </template>
                    </c-detail-item>
                    <c-detail-item label="指定目标用户" full v-if="taskInfo.task_user_type==2">
						<c-table v-model="memberList" v-if="taskInfo.task_user_type==2" height="auto" border>

							<c-table-column
								label="手机号"
								name="user_manage_mobilephone"
							></c-table-column>
							
							<c-table-column
								label="昵称"
								name="nick_name"
							></c-table-column>
						</c-table>
					</c-detail-item>
				</c-detail>
				
				<c-detail title="发放策略">
					<c-detail-item label="优惠券" full>
						<c-table v-model="couponList" height="auto" border>
							<c-table-column
								label="优惠券名称"
								name="coupon_name"
								width="120"
							></c-table-column>
							
							<c-table-column
								label="优惠力度"
								name="detail"
								width="120"
							></c-table-column>
							
							<c-table-column
								label="适用范围"
								name="commodity_range"
								width="70"
							>
								<template v-slot="{data}">
									{{dict.couponRange[data.commodity_range]}}
								</template>
							</c-table-column>
							
							<c-table-column
								label="剩余可领"
								name="surplus"
								width="70"
							></c-table-column>
							
							<c-table-column
								required
								label="有效期"
								width="310"
							>
								<template v-slot="row">
									<span v-if="row.data.valid_date_type" style="margin-right: 5px;">{{row.data.valid_date_type == 1 ? `${row.data.valid_start_date} - ${row.data.valid_end_date}` : `领取后${row.data.effective_days}天内`}}</span>
								</template>
							
							</c-table-column>
							
							<c-table-column
								label="每人限领"
								width="80"
								name="received_count"
							></c-table-column>
							
							<c-table-column
								label="券标签"
								width="80"
								name="coupon_tag"
							></c-table-column>
						</c-table>
					</c-detail-item>
					<c-detail-item label="发放时间" full v-if="taskInfo.task_user_type==2">{{taskInfo.execute_type == 1 ? '立即发放' : taskInfo.scheduled_execute_date}}</c-detail-item>
					<c-detail-item label="备注" full>{{taskInfo.remark}}</c-detail-item>
				</c-detail>
			</div>
			
			<template v-if="verify" slot="button">
				<c-button size="m" @click="verifyHandle(2)">审核通过</c-button>
				<c-button size="m" color="red" @click="verifyHandle(-1)">审核驳回</c-button>
			</template>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		name: 'coupon_task_detail',
		
		props: {
			id: String,
			
			verify: Boolean
		},
		
		data() {
			return {
				taskInfo: '',
				memberList: [],
				couponList: []
			}
		},
		
		computed: {
			...mapState(['dict'])
		},
		
		watch: {
			id() {
				this.getTaskDetail();
			}
		},
		
		mounted() {
			this.getTaskDetail();
		},
		
		methods: {
			getTaskDetail() {
				this.request({
					url: '/couponInfo/task/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.taskInfo = data;
						this.memberList = data.user_list || [];
						this.couponList = data.coupon_list || [];
                        this.taskInfo.error_reason_text = this.taskInfo.error_reason?this.taskInfo.error_reason.replace(/\n/g,'<br>'):''; //js 代码
                    }
				});
			},
			
			verifyHandle(state) {
				this.request({
					url: '/couponInfo/task/approval',
					data: {
						id: this.id,
						state
					},
					loading: true,
					success: () => {
						this.$message({
							text: '审核成功'
						});
						this.$bus.$emit('couponTaskList.update');
						this.redirectTo('/coupon_task');
					}
				});
			}
		}
	}
</script>
<style>
    text-box {
        white-space: pre-wrap;
    }
</style>